import React from "react";
import MainBiz from "../../../Component/Products/biz";

const Biz = () => <MainBiz />;

export default Biz;
